import Header from "./components/Header";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Docs from "./components/Docs";
import IndexTabs from "./components/IndexTabs";
import Witness from "./components/Witness";
import Community from "./components/Community";
import MethodNote from "./components/MethodNote";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="method" className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <Feed />
        <Docs />
        <IndexTabs />
        <Witness />
        <Community />
        <MethodNote />
      </main>
      <Footer />
    </div>
  );
}